import * as React from "react"
// import ImageMarathon from "./ImageMarathon"

const MarathonAbout = ({ aboutMarathonRef, isAboutMarathonPlay }) => (
  <div id="aboutMarathon" ref={aboutMarathonRef} className="blog-content">
    <div className="container">
      {/*<ImageMarathon />*/}
      <div className="article-block w-richtext">
        <h2>О марафоне</h2>
        <ul>
          <li>
            <b>30-ти дневный</b> оффлайн марафон в зале, который{" "}
            <b>дисциплинирует</b> и заставляет <b>поверить</b> в себя;
          </li>
          <li>
            Вас ждут <b>зажигательные</b> тренировки:
            <br />
            – Cиловые
            <br />
            – Кардио
            <br />
            – Круговые
            <br />
            – Функциональные
            <br />
            – Табата
            <br />– Стрейчинг
          </li>
          <li>
            Вас ждёт насыщенная <b>программа</b>, которая разработана так, чтобы
            ваш процесс <b>похудения</b> проходил легко, быстро и комфортно:
            <br />
            – План питания;
            <br />– Домашние задания-тренировки (тариф <b>стандарт</b> и{" "}
            <b>голд</b>);
            <br />– Мотивация и задания каждый день в чате (тарифы{" "}
            <b>стандарт</b> и <b>голд</b>);
            <br />– Контроль о отчёты о выполнении заданий (тарифы{" "}
            <b>стандарт</b> и <b>голд</b>).
          </li>
          <li>
            Программа подойдёт для <b>любого уровня</b> подготовки и
            предусматривает постепенное увеличение нагрузки;
          </li>
          <li>
            Вы сможете <b>избежать срывов</b> и достигнуть{" "}
            <b>желаемого результата</b>, наполнитесь{" "}
            <b>положительными эмоциями</b> и зарядитесь <b>энергией</b> для
            новых побед.
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default MarathonAbout
